var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0L18 0C19.5913 0 21.1174 0.632141 22.2426 1.75736C23.3679 2.88258 24 4.4087 24 6V18C24 19.5913 23.3679 21.1174 22.2426 22.2426C21.1174 23.3679 19.5913 24 18 24H6C4.4087 24 2.88258 23.3679 1.75736 22.2426C0.632141 21.1174 0 19.5913 0 18V6ZM10.494 6.2475C10.4618 6.03063 10.4768 5.80937 10.5379 5.5988C10.599 5.38823 10.7047 5.19331 10.8479 5.02729C10.9911 4.86128 11.1684 4.72809 11.3678 4.6368C11.5671 4.5455 11.7838 4.49824 12.003 4.49824C12.2222 4.49824 12.4389 4.5455 12.6382 4.6368C12.8376 4.72809 13.0149 4.86128 13.1581 5.02729C13.3013 5.19331 13.407 5.38823 13.4681 5.5988C13.5292 5.80937 13.5442 6.03063 13.512 6.2475L12 16.5L10.494 6.2475ZM12 16.5C12.3978 16.5 12.7794 16.658 13.0607 16.9393C13.342 17.2206 13.5 17.6022 13.5 18C13.5 18.3978 13.342 18.7794 13.0607 19.0607C12.7794 19.342 12.3978 19.5 12 19.5C11.6022 19.5 11.2206 19.342 10.9393 19.0607C10.658 18.7794 10.5 18.3978 10.5 18C10.5 17.6022 10.658 17.2206 10.9393 16.9393C11.2206 16.658 11.6022 16.5 12 16.5Z",
    fill: "#428BC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoIcon);
export default __webpack_public_path__ + "static/media/Expo-Icon.e69a5194e98a1835c584cc1a6c0e8e99.svg";
export { ForwardRef as ReactComponent };